<template>
	<div>
		<el-dialog
			:title="title"
			:visible.sync="dialogFormVisible"
			:close-on-click-modal="false"
			width="929px"
			custom-class="dialog-style"
			:append-to-body="true"
			@close="handleClose"
		>
			<div class="upload-box">
				<div class="tips">注意：当前所有文件上传完，才允许确定操作，单个文件大小限制{{ fileMaxSize }}MB。</div>
				<el-upload
					ref="upload"
					:action="action"
					:http-request="uploadSectionFile"
					:auto-upload="true"
					:close-on-click-modal="false"
					:data="data"
					:file-list="fileList"
					:headers="headers"
					:limit="limit"
					:multiple="true"
					:name="name"
					:on-change="handleChange"
					:on-error="handleError"
					:on-exceed="handleExceed"
					:on-preview="handlePreview"
					:on-progress="handleProgress"
					:on-remove="handleRemove"
					:on-success="handleSuccess"
					:before-upload="handleBeforeUpload"
					:accept="accept"
					class="upload-demo"
					list-type="picture"
				>
					<div class="avatar-uploader" slot="trigger"><i class="el-icon-plus avatar-uploader-icon"></i></div>
					<div slot="file" slot-scope="{ file }">
						<img :src="getShowImage(file)" class="el-upload-list__item-thumbnail" />
						<div class="el-upload-list__item-name">
							<p>{{ file.name }}</p>
							<p v-if="file.status == 'success'">{{ formatFileSize(file.size) }}</p>
						</div>
						<el-progress :percentage="file.percentage" v-if="file.status == 'uploading'"></el-progress>
						<div class="el-upload-list__item-status-label" v-else-if="file.status == 'success'"><i class="el-icon-upload-success el-icon-check"></i></div>
						<div class="el-upload-list__item-status-label load" v-else-if="file.status == 'ready'"><i class="el-icon-loading"></i></div>
						<div class="el-upload-list__item-status-label error" v-else><i class="el-icon-upload-success el-icon-close"></i></div>
						<div class="el-icon-close" @click="removeFile(file)">
							<el-tooltip :enterable="false" effect="dark" content="删除" placement="top" popper-class="tooltip-skin"><i class="iconfont iconshanchu"></i></el-tooltip>
						</div>
					</div>
					<el-dialog :visible.sync="dialogVisible" append-to-body title="查看大图">
						<div><img :src="dialogImageUrl" alt="" width="100%" /></div>
					</el-dialog>
				</el-upload>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" plain class="button-sty" @click="handleClose">
					<i class="el-icon-close el-icon"></i>
					取 消
				</el-button>
				<el-button type="primary" @click="submitImage" class="button-sty">
					<i class="el-icon-check el-icon"></i>
					确 定
				</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { mixins } from './mixins';
export default {
	mixins: [mixins]
};
</script>

<style lang="scss" scoped>
.pup-annex-box {
	height: 355px;
	background: #fff;
}
</style>
